import { createUseStyles } from "react-jss";

const InvoiceNotesListStyles = createUseStyles({
    pageContent: {
        backgroundColor: "#FFF",
        borderRadius: "5px",
        border: "solid 1px #eee",
        '& table > thead > tr > th.MuiTableCell-head': {
            color: '#000000',
            fontWeight: 'bold',
            fontFamily: 'Bogle'
        },
        '& table > thead > tr > th.MuiTableCell-head button': {
            color: '#000000',
            fontWeight: 'bold',
            fontFamily: 'Bogle'
        },
    },
    noteTabNavigation: {
        backgroundColor: "#fff",
    },
    disableTabs: {
        opacity: 0.5,
        pointerEvents: "none"
    },
});

export default InvoiceNotesListStyles;